import { Injectable } from '@angular/core';
import { PoTableColumn } from '@po-ui/ng-components';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdmOrcamentoListService {
  //
  urlOrcamentos = `${environment.API}listaOrcamento`;
  urlCliente = `${environment.API}clientes`;
  urlcabOrcamento = `${environment.API}cabOrcamento`;
  urlVendaOrcamento = `${environment.API}protheus/venda`;
  urlItensOrcamento = `${environment.API}itensorcamento`;
  urlEmail = `${environment.API}email`;
  get headers(): HttpHeaders {
    return new HttpHeaders({ authorization: sessionStorage.getItem("token") || "" });
  }

  constructor(private http: HttpClient) { }

  getOrcamentoList(id): Observable<any> {
    let adm = "A";
    return this.http.post(this.urlOrcamentos, { id, adm },{headers: this.headers});
  }

  getNomeCliente(cgc, segmto): Observable<any> {
    return this.http.post(this.urlCliente, { cgc, tiporeq: 'C', segmto:segmto },{headers: this.headers});
  }

  deleteCabOrcamento(id): Observable<any> {
    return this.http.delete(this.urlOrcamentos + '/' + id,{headers: this.headers});
  }

  vendaOrcamento(Orcamento: object): Observable<any> {
     return this.http.post(this.urlVendaOrcamento, Orcamento,{headers: this.headers});
  }

  enviaEmail(email, orcamento, codigo): Observable<any> {
    return this.http.post(this.urlEmail, {
      email: email, orcamento: orcamento,
      codigo: codigo, url: '' //'http://localhost:4200/orcamentocliente/'
    },{headers: this.headers});
  }
  
  SalvaCabOrcamento(cabOrcamento: Array<any>): Observable<any> {
    return this.http.post(this.urlcabOrcamento, cabOrcamento,{headers: this.headers});
  }

  getCabOrcamento(id: number): Observable<any> {
    return this.http.post(this.urlOrcamentos, {
      id: id,
    },{headers: this.headers});
  }

  getItensOrcamento(id: number): Observable<any> {
    return this.http.post(this.urlItensOrcamento, {
      id: id,
    },{headers: this.headers});
  }


  getColumns(): Array<PoTableColumn> {
    return [
      { property: 'numOrcamento', label: 'Orçamento' },
      { property: 'numPedido', label: 'Pedido' },
      { property: 'nome', label: 'Cliente' },
      { property: 'cgc', label: 'CNPJ/CPF' },
      {
        property: 'emissao',
        label: 'Emissão',
        type: 'date',
        format: 'dd/MM/yyyy',
      },
      { property: 'segmto', label: 'Seguimento' },
      { property: 'status', label: 'Situação' },
    ];
  }
}
